export const FETCH_MATERIAL_UPDATES_START = 'FETCH_MATERIAL_UPDATES_START';
export const FETCH_MATERIAL_UPDATES_SUCCESS = 'FETCH_MATERIAL_UPDATES_SUCCESS';
export const FETCH_MATERIAL_UPDATES_FAIL = 'FETCH_MATERIAL_UPDATES_FAIL';

export const FETCH_SINGLE_MATERIAL_UPDATE_START = 'FETCH_SINGLE_MATERIAL_UPDATE_START';
export const FETCH_SINGLE_MATERIAL_UPDATE_SUCCESS = 'FETCH_SINGLE_MATERIAL_UPDATE_SUCCESS';
export const FETCH_SINGLE_MATERIAL_UPDATE_FAIL = 'FETCH_SINGLE_MATERIAL_UPDATE_FAIL';

export const CREATE_MATERIAL_UPDATE_START = 'CREATE_MATERIAL_UPDATE_START';
export const CREATE_MATERIAL_UPDATE_SUCCESS = 'CREATE_MATERIAL_UPDATE_SUCCESS';
export const CREATE_MATERIAL_UPDATE_FAIL = 'CREATE_MATERIAL_UPDATE_FAIL';

export const UPDATE_MATERIAL_UPDATE_START = 'UPDATE_MATERIAL_UPDATE_START';
export const UPDATE_MATERIAL_UPDATE_SUCCESS = 'UPDATE_MATERIAL_UPDATE_SUCCESS';
export const UPDATE_MATERIAL_UPDATE_FAIL = 'UPDATE_MATERIAL_UPDATE_FAIL';

export const DELETE_MATERIAL_UPDATE_START = 'DELETE_MATERIAL_UPDATE_START';
export const DELETE_MATERIAL_UPDATE_SUCCESS = 'DELETE_MATERIAL_UPDATE_SUCCESS';
export const DELETE_MATERIAL_UPDATE_FAIL = 'DELETE_MATERIAL_UPDATE_FAIL';

export const CLEAR_CURRENT_UPDATE = 'CLEAR_CURRENT_UPDATE';
export const CLEAR_MASTER_DATA_UPDATES_CACHE = 'CLEAR_MASTER_DATA_UPDATES_CACHE';

export const FETCH_MASTER_DATA_UPDATES_BY_PROFILE = 'FETCH_MASTER_DATA_UPDATES_BY_PROFILE';
export const FETCH_MASTER_DATA_UPDATES_BY_PROFILE_SUCCESS = 'FETCH_MASTER_DATA_UPDATES_BY_PROFILE_SUCCESS';
export const FETCH_MASTER_DATA_UPDATES_BY_PROFILE_FAIL = 'FETCH_MASTER_DATA_UPDATES_BY_PROFILE_FAIL';

export const SUPPLIER_DETAILS_BY_UPDATE_NO = 'SUPPLIER_DETAILS_BY_UPDATE_NO';
export const SUPPLIER_DETAILS_BY_UPDATE_NO_FAIL = 'SUPPLIER_DETAILS_BY_UPDATE_NO_FAIL';

export const SET_MESSAGE_DIALOG_DATA = 'SET_MESSAGE_DIALOG_DATA';

export const FETCH_CUSTOMER_MASTER_START = 'FETCH_CUSTOMER_MASTER_START';
export const FETCH_CUSTOMER_MASTER_SUCCESS = 'FETCH_CUSTOMER_MASTER_SUCCESS';
export const FETCH_CUSTOMER_MASTER_FAIL = 'FETCH_CUSTOMER_MASTER_FAIL';

export const FETCH_CUSTOMER_MASTER_BY_ID_START = 'FETCH_CUSTOMER_MASTER_BY_ID_START';
export const CLEAR_FETCH_CUSTOMER_MASTER_BY_ID = 'CLEAR_FETCH_CUSTOMER_MASTER_BY_ID';
export const FETCH_CUSTOMER_MASTER_BY_ID_SUCCESS = 'FETCH_CUSTOMER_MASTER_BY_ID_SUCCESS';
export const FETCH_CUSTOMER_MASTER_BY_ID_FAIL = 'FETCH_CUSTOMER_MASTER_BY_ID_FAIL';

export const FETCH_APPROVAL_PAGE_DETAILS = 'FETCH_APPROVAL_PAGE_DETAILS';

export const FETCH_CUSTOMER_UPDATE_DEFAULT_PROFILE_START = 'FETCH_CUSTOMER_UPDATE_DEFAULT_PROFILE_START';
export const FETCH_CUSTOMER_UPDATE_DEFAULT_PROFILE_SUCCESS = 'FETCH_CUSTOMER_UPDATE_DEFAULT_PROFILE_SUCCESS';
export const FETCH_CUSTOMER_UPDATE_DEFAULT_PROFILE_FAIL = 'FETCH_CUSTOMER_UPDATE_DEFAULT_PROFILE_FAIL';

export const FETCH_CUSTOMER_MASTER_GROUPED_START = 'FETCH_CUSTOMER_MASTER_GROUPED_START';
export const FETCH_CUSTOMER_MASTER_GROUPED_SUCCESS = 'FETCH_CUSTOMER_MASTER_GROUPED_SUCCESS';
export const FETCH_CUSTOMER_MASTER_GROUPED_FAIL = 'FETCH_CUSTOMER_MASTER_GROUPED_FAIL';

export const GET_MASTER_DATA_PROFILE = 'GET_MASTER_DATA_PROFILE';
export const CLEAR_MASTER_DATA_PROFILE = 'CLEAR_MASTER_DATA_PROFILE';
export const GET_MASTER_DATA_PROFILE_BY_NAME_SUCCESS = 'GET_MASTER_DATA_PROFILE_BY_NAME_SUCCESS';
export const GET_CUSTOMER_BY_PROFILE_SUCCESS = 'GET_CUSTOMER_BY_PROFILE_SUCCESS';
export const CLEAR_CUSTOMER_BY_PROFILE = 'CLEAR_CUSTOMER_BY_PROFILE';
export const CLONE_CUSTOMER_MASTER_SUCCESS = 'CLONE_CUSTOMER_MASTER_SUCCESS';